module.exports = __webpack_public_path__ + "assets/img/unchecked.27c880d9.svg";